module.exports = __webpack_public_path__ + "img/2.059ae74e.jpg";